module.exports = __webpack_public_path__ + "static/img/loading.14a0936b.gif";